import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Gallery } from './components/Gallery';
import { Reviews } from './components/Reviews';
import { QuoteForm } from './components/QuoteForm';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-1" data-id="element-2">
        <Hero data-id="element-3" />
        <Services data-id="element-4" />
        <Gallery data-id="element-5" />
        <Reviews data-id="element-6" />
        <QuoteForm data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}